export default __webpack_public_path__ + "static/media/img-splice-1.b8758781.png";